<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      <!------------------------头部搜索开始---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
		  <el-form-item style="width:23%">
              <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
          </el-form-item>
		  <el-form-item style="width:12%">
          	  <el-select v-model="query.brandid" clearable filterable placeholder="请选择品牌">
              	  <el-option label="不分品牌" value="0"></el-option>
                  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>
          </el-form-item>
		  <el-form-item style="width:12%">
              <el-cascader :options="categorylistsearch" v-model="query.catid" placeholder="请选择分类" clearable></el-cascader>
          </el-form-item>
          <el-form-item style="width:10%">
          	  <el-select v-model="query.type" filterable @change="changeType">
                  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item style="width:15%">
              <el-select v-model="query.productid" clearable filterable remote reserve-keyword :remote-method="getProducts" :loading="customerLoading" placeholder="请选择商品" v-if="query.type==1">
          		<el-option v-for="(item,index) in productlists" :key="index" :label="item.name" :value="item.id"></el-option>
        	  </el-select>
              <el-select v-model="query.customer" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="请选择客户" v-if="query.type==2">
          		<el-option v-for="(item,index) in customerLists" :key="index" :label="item.name" :value="item.id"></el-option>
        	  </el-select> 
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
              <el-button type="primary" icon="el-icon-edit-outline" @click="exportdatamore">批量导出</el-button>
          </el-form-item>
      </el-form>
      <!------------------------头部搜索结束---------------------->
      
      <!------------------------统计类表开始---------------------->
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listLoading">
	          <el-table-column prop="customername" label="客户名称（简称）"></el-table-column>
	          <el-table-column prop="phone" label="电话" width="150" align="center"></el-table-column>
	          <el-table-column prop="money" label="消费金额" width="150" align="center"></el-table-column>
	          <el-table-column prop="number" label="进货次数" width="150" align="center"></el-table-column>
	          <el-table-column label="操作" width="180" align="center">
	              <template slot-scope="scope">
	                  <el-button type="primary" size="small" icon="el-icon-search" @click="editCurrent(scope.row)"></el-button>
	                  <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="exportdata(scope.row)">导出商品</el-button>
	              </template>
	          </el-table-column>
	      </el-table>
	      <div class="block">
	          <el-pagination
	              @size-change="pageSizeChange"
	              @current-change="pageCurrentChange"
	              :current-page="query.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="query.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="total_rows">
	          </el-pagination>
	      </div>
      </div>
      <!------------------------统计类表结束---------------------->
      
      <!------------------------统计订单列表开始------------------->
      <el-dialog title="查看消费详情" :visible.sync="showorder" width="75%" top="7vh">
      	  <el-table :data="orderlists" v-loading="OrderLoading" style="100%">
      	  
      	  	  <el-table-column type="expand">
				  <template slot-scope="props">
		              <el-table :data="props.row.goods">
		                <el-table-column prop="name" label="商品名称"></el-table-column>
		                <el-table-column prop="spec" label="规格" align="center" width="120"></el-table-column>
		                <el-table-column prop="num" label="数量" align="center" width="120"></el-table-column>
		                <el-table-column prop="unit" label="单位" align="center" width="90"></el-table-column>
		                <el-table-column prop="sell" label="价格" align="center" width="150"></el-table-column>
		                <el-table-column prop="discount" label="折扣（%）" align="center" width="90"></el-table-column>
		                <el-table-column prop="total" label="总价" align="center" width="150"></el-table-column>
		              </el-table>
	              </template>
			  </el-table-column>
      	  
	          <el-table-column prop="documents" label="订单号"></el-table-column>
	          <el-table-column prop="clerkname" label="销售员" align="center" width="120"></el-table-column>
	          <el-table-column prop="total" label="总金额" align="center" width="120"></el-table-column>
	          <el-table-column prop="inputtime" label="下单时间" align="center" width="180"></el-table-column>
      	  </el-table>
	      <div class="block">
	          <el-pagination
	              @size-change="orderpageSizeChange"
	              @current-change="orderpageCurrentChange"
	              :current-page="search.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="search.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="order_total_rows">
	          </el-pagination>
	      </div>
      </el-dialog>
      <!------------------------统计订单列表结束------------------->
      
      <!---------------------------- 导出信息确认 ---------------------------->
	  <el-dialog title="导出信息确认" :visible.sync="outputDialog" width="98%" top="5vh">
	  	  <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      <div id="outputorder">
		  	  <el-table :data="outlists" border v-loading="outlistsLoading">
		      	  <el-table-column prop="customername" label="客户名称" width="90"></el-table-column>
		      	  <el-table-column prop="finishtime" label="完成时间" width="90"></el-table-column>
		          <el-table-column prop="brandname" label="所属品牌"></el-table-column>
		          <el-table-column prop="name" label="商品名称"></el-table-column>
		          <el-table-column prop="code" label="条形码" align="center"></el-table-column>
		          <el-table-column prop="spec" label="规格" align="center"></el-table-column>
		          <el-table-column prop="num" label="数量" width="100" align="center"></el-table-column>
		          <el-table-column prop="unit" label="单位" width="100" align="center"></el-table-column>
		          <el-table-column prop="sell" label="批发价" width="100" align="center"></el-table-column>
		          <el-table-column prop="market" label="零售价" align="center"></el-table-column>
		          <el-table-column prop="dis_sell" label="售价" align="center"></el-table-column>
		          <el-table-column prop="total" label="小计" align="center"></el-table-column>
		          <el-table-column prop="type" label="类型" align="center"></el-table-column>
		          <el-table-column prop="desc" label="备注" align="center"></el-table-column>	          	  	          	  
		      </el-table>
	     </div>
	     <div slot="footer" class="dialog-footer">
		     <el-button size="medium" @click="outputDialog=false">取 消</el-button>
		     <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		 </div>	                
	 </el-dialog>   
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Stat/index",
      transitionshow:true,
      showorder:false,
      customerLoading:false,
      listLoading:false,
      orderLoading:false,
      query: {
          token:this.$cookies.get('token'),
          act:'customerstat',
          key:'',
          coststart:'',
          costend:'',
          rollpage: 10, // 页大小
          p: 1,
          date:[],
          brandid:'',
          catid:'',
          customer:'',
          type:1,
          productid:'',
      },
      search: {
      	  act:'searchdeatil',
      	  token:this.$cookies.get('token'),
      	  key:'',
          coststart:'',
          costend:'',
          rollpage: 10, // 页大小
          p: 1,
          date:[],
          brandid:'',
          catid:'',
          customer:'',
          type:1,
          productid:'',
      },
      
      typelists: [
      	  {id:1,name:'按产品'},
      	  {id:2,name:'按客户'},
      ],
      lists:[],
      categorylistsearch:[],
      brandlists:[],
      customerLists:[],
      orderlists:[],
      total_rows:0,
      order_total_rows:0,
      productlists:[],
      outputDialog:false,
      outlists:[],
      outlistsLoading:false,
      
    }
  },
  mounted(){
      this.getCategoryList(); //获取商品分类
      this.getBrand(); //获取商品品牌
      this.getlists(); //获取客户统计信息
  },
  methods:{
  
  	  //查询客户统计信息
  	  getlists(){
  	  	  this.listLoading=true;
	      var resource = this.$resource(this.url);
	      resource.query(this.query).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		          this.listLoading=false;
	          }else{
		          this.lists = JSON.parse(Base64.decode(res.data.Data));
		          this.total_rows=parseInt(res.data.count);
		          this.listLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.listLoading=false;
	      });
      },
      
      pageSizeChange(val) {
          this.query.rollpage = val;
          this.getlists();
      },
      pageCurrentChange(val) {
          this.query.p = val;
          this.getlists();
      },
      
      orderpageSizeChange(val) {
          this.search.rollpage = val;
          this.getorders();
      },
      orderpageCurrentChange(val) {
          this.search.p = val;
          this.getorders();
      },
      
      
      //选择类型改变，清空原来选择的商品信息和客户信息
      changeType() {
      	  this.query.productid='';
		  this.query.customer='';
      },
  	  
  
      //获取分类列表
      getCategoryList(){
	      var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	      resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
	          }else{
		          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
		          var _this=this;
		          this.categorylistsearch.push({value:0,label:'不选择分类'});
		          this.categorylist.forEach(function(e,index) {
		          	  _this.categorylistsearch.push(e);
	          });
	          
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      //获取品牌
      getBrand(){
	      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
	      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
	          }else{
	          	  this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      /** 获取客户信息 **/
      getCustomer(query){
	      if(query !== '') {
	          this.customerLoading = true;
	          var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	          resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.customerLoading = false;
	          }else{
	              this.customerLists = JSON.parse(Base64.decode(res.data.Data));
	              this.customerLoading = false;
	          }
	          }).catch((res) => {
	              this.$message.error(this.GLOBAL.errortext);
	              this.customerLoading = false;
	          });
	      }
      },
      
      /** 获取需要搜索的商品信息 **/
      getProducts(name) {
      	  if(name !== '') {
      	  	  this.customerLoading = true;
	          var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	          resource.query({act:'lists',key:name,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.customerLoading = false;
	          }else{
	              this.productlists = JSON.parse(Base64.decode(res.data.Data));
	              this.customerLoading = false;
	          }
	          }).catch((res) => {
	              this.$message.error(this.GLOBAL.errortext);
	              this.customerLoading = false;
	          });
      	  }
      },
      
      //查询消费详情
      editCurrent(obj) {
      	  this.search.productid=this.query.productid;
      	  this.search.date=this.query.date;
      	  this.search.brandid=this.query.brandid;
      	  this.search.catid=this.query.catid;
      	  this.search.customer=obj.customerid;
      	  this.search.rollpage=10;
      	  this.search.p=1;
      	  this.getorders();
      },
      
      //查看具体销售统计订单
      getorders() {
      	  this.showorder=true;
      	  this.orderLoading=true;
      	  var resource = this.$resource(this.url);
	      resource.query(this.search).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.orderLoading = false;
	          }else{
	              this.orderlists = JSON.parse(Base64.decode(res.data.Data));
	              this.order_total_rows=parseInt(res.data.count);
	              this.orderLoading = false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.orderLoading = false;
	      });  
      },
      
      //导出商品详情
      exportdata(obj) {
      	  this.outputDialog=true;
      	  this.getexportdata(obj.customerid);
      },
      
      //批量导出
      exportdatamore() {
      	  this.outputDialog=true;
      	  var customerid=this.query.customer=='' ? 'allcustomer' : this.query.customer;
      	  this.getexportdata(customerid);
      },
      
      getexportdata(customerid) {
		  alert("wellcome");
      	  this.outlistsLoading=true;
      	  var resource = this.$resource(this.url);
	      resource.query({act:'getexportdata',token:this.$cookies.get('token'),customer:customerid,brandid:this.query.brandid,date:this.query.date,productid:this.query.productid,catid:this.query.catid}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.outlistsLoading=false;
	          }else{
	              this.outlists = JSON.parse(Base64.decode(res.data.Data));
	              this.outlistsLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.outlistsLoading=false;
	      }); 
      },
      
      /** 确认导出订单信息 **/
      sureoutput() {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  var tHeader = ['客户名称','完成时间','品牌','商品名称','条形码','规格','数量','单位','批发价','零售价','售价','小计','类型','备注'];
			  var filterVal = ['customername','finishtime','brandname','name','code','spec','num','unit','sell','market','dis_sell','total','type','desc'];
				
			  var list = this.outlists;
			  var data = this.formatJson(filterVal, list);
			  export_json_to_excel(tHeader, data, '客户消费记录');
			  this.outputDialog=false;
		  })
      },
    
      //导出表格数据
	  formatJson(filterVal, jsonData) {
　　　　	  return jsonData.map(v => filterVal.map(j => v[j]));
　　       },
      
      
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/Customerstat.vue